import { Settings } from "@mui/icons-material";
import { Box } from "@mui/material";
import { FullWidthContainer } from "../../components/FullWidthContainer";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import SettingsDrawer from "../../components/SettingsDrawer";
import { Table } from "./components/Table";

export function ApiKeys() {
  return (
    <>
      <Helmet>
        <title>API Keys</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="API Keys"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <FullWidthContainer>
              <Table />
            </FullWidthContainer>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
